import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as scActions from './employee-salary.actions'
import { catchError, exhaustMap, map, mergeMap, of, switchMap } from 'rxjs'
import { EmployeeSalary } from './employee-salary.state'
import { EmployeeSalaryService } from '../../services/employee-salary.service'
import { ToastrService } from 'ngx-toastr'

//Load All Salaries Effect
export const loadAllSalaries$ = createEffect(
  (actions$ = inject(Actions), esService = inject(EmployeeSalaryService)) =>
    actions$.pipe(
      ofType(scActions.loadAllSalaries),
      switchMap(({ belongsTo, employeeId }) =>
        esService.loadAllSalaries(employeeId, belongsTo).pipe(
          map((salaries: EmployeeSalary[]) => scActions.loadAllSalariesSuccess({ salaries })),
          catchError(error => of(scActions.loadAllSalariesFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

//Load Salary Effect
export const loadSalary$ = createEffect(
  (actions$ = inject(Actions), esService = inject(EmployeeSalaryService)) =>
    actions$.pipe(
      ofType(scActions.loadSalary),
      switchMap(({ belongsTo, employeeId }) =>
        esService.loadSalary(employeeId, belongsTo).pipe(
          map((salary: EmployeeSalary) => scActions.loadSalarySuccess({ salary })),
          catchError(error => of(scActions.loadSalaryFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// Add Salary Effect
export const addSalary$ = createEffect(
  (
    actions$ = inject(Actions),
    esService = inject(EmployeeSalaryService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(scActions.addSalary),
      exhaustMap(({ salary }) =>
        esService.addSalary(salary).pipe(
          map((savedSalary: EmployeeSalary) => {
            toastr.success('Salary added Successfully!')
            return scActions.addSalarySuccess({ salary: savedSalary })
          }),
          catchError(error => {
            toastr.error('Failed to Add ' + error.message)
            return of(scActions.addSalaryFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

// Edit Salary Effect
export const editSalary$ = createEffect(
  (
    actions$ = inject(Actions),
    esService = inject(EmployeeSalaryService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(scActions.editSalary),
      exhaustMap(({ salary }) =>
        esService.updateSalary(salary).pipe(
          map((savedSalary: EmployeeSalary) => {
            toastr.success('Updated Successfully!')
            return scActions.editSalarySuccess({ salary: savedSalary })
          }),
          catchError(error => {
            toastr.error('Failed to Update ' + error.message)
            return of(scActions.addSalaryFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

// Delete Salary Effect
export const deleteSalary$ = createEffect(
  (actions$ = inject(Actions), esService = inject(EmployeeSalaryService)) =>
    actions$.pipe(
      ofType(scActions.deleteSalary),
      exhaustMap(({ id }) =>
        esService.deleteSalary(id).pipe(
          map(({ status }) =>
            status === 'success'
              ? scActions.deleteSalarySuccess({ id })
              : scActions.deleteSalaryFailure({ error: status })
          ),
          catchError(error => of(scActions.addSalaryFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// Revise Salary Effect
export const saveRevisedSalary$ = createEffect(
  (
    actions$ = inject(Actions),
    esService = inject(EmployeeSalaryService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(scActions.salaryRevisionActions.saveRevisedSalary),
      exhaustMap(({ salary }) =>
        esService.addSalary(salary).pipe(
          map((savedSalary: EmployeeSalary) => {
            toastr.success('Revised Successfully!')
            return scActions.salaryRevisionActions.saveRevisedSalarySuccess({ salary: savedSalary })
          }),
          catchError(error => {
            toastr.error('Failed to Revise ' + error.message)
            return of(
              scActions.salaryRevisionActions.saveRevisedSalaryFailure({ error: error.message })
            )
          })
        )
      )
    ),
  { functional: true }
)

//Load Salaries by BusinessId Effect
//export const loadSalariesByBusiness$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    esService = inject(EmployeeSalaryService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(loadAllSalariesByBusinessId.loadSalaries),
//      mergeMap(({ businessId }) =>
//        esService.loadLatestSalariesOfBusiness(businessId).pipe(
//          map((salaries: EmployeeSalaryWithUser[]) =>
//            loadAllSalariesByBusinessId.loadSalariesSuccess({ salaries })
//          ),
//          catchError(error => {
//            toastr.error(error.message)
//            return of(loadAllSalariesByBusinessId.loadSalariesFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

export const employeeSalaryEffects = {
  loadAllSalaries$,
  loadSalary$,
  addSalary$,
  editSalary$,
  deleteSalary$,
  saveRevisedSalary$
  //loadSalariesByBusiness$
}
